'use client'
import { useEffect, useState } from "react";
import axios from "axios";

const cache = new Map<string, any>(); // Кеш для хранения данных по URL

export const useFetchClientSide = (url: string) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [meta, setMeta] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (cache.has(url)) {
        // Если данные есть в кеше, используем их
        const cachedData = cache.get(url);
        setData(cachedData.data);
        setMeta(cachedData.meta);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const res = await axios.get(url);
        const fetchedData = {
          data: res.data?.data,
          meta: res?.data?.meta?.pagination,
        };

        // Сохраняем данные в кеше
        cache.set(url, fetchedData);

        setData(fetchedData.data);
        setMeta(fetchedData.meta);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  return { data, loading, error, meta };
};
